<div class="row no-gutters">
  <div class="col-lg-12">
   <h2>
     {{"about" | translate }}
   </h2>
   <div class="container" *ngIf="loading">
     <div class="row">
       <div class="col-lg-12">
            <app-form-spinner></app-form-spinner>
       </div>
     </div>
   </div>
   <div class="card px-4 p-6 mb-4 rounded-4 shadow" *ngIf="!loading">
     <form  [formGroup]="form" (ngSubmit)="onSubmit()" *ngIf="user!=null">
       <div class="row no-gutters">
         <div class="col-lg-2 mb-2" *ngIf="user.image!=''">
           <img src="{{user.image}}" alt="" class="img-fluid avatar avatar-xl rounded-circle shadow">
         </div>
         <div class="col-lg-2 mb-2" *ngIf="user.image==''">
           <img src="{{imageUrl}}" alt="" class="img-fluid avatar avatar-xl rounded-circle shadow">
         </div>
          <div class="col-lg-10 d-grid">
           <button type="button" class="btn btn-primary py-2  mb-2 rounded-4"   *ngIf="loading">
             <div class="spinner-border text-light" role="status">
             <span class="visually-hidden">
              {{"loading" | translate}}
             </span>
           </div>
          </button>
          
           <button (click)="openGallery()" *ngIf="!loading" type="button" class="btn btn-primary py-3  mb-2 rounded-4"   >
            {{"pickImage" | translate}}
           </button>

           <button *ngIf="loading" type="button" class="btn btn-primary py-3  mb-2 rounded-4"    >
                <app-button-spinner></app-button-spinner>
           </button>
           <button type="submit" class="btn btn-light py-3 btn-block rounded-4" type="submit"  [disabled]="form.invalid" *ngIf="!loading">
            {{"save" | translate}}
           </button>
           <button *ngIf="loading" type="button" class="btn btn-primary py-3  mb-2 rounded-4"    >
            <app-button-spinner></app-button-spinner>
       </button>
          </div>
          <div class="col-lg-12 mt-5">
            <label for="Title">
              {{"titleProfile" | translate}}
            </label>
           <input type="text" id="Title" [placeholder]="'profileTitle' | translate" class="form-control my-2 py-3 rounded-2"  formControlName="title">
            <label for="description">
              {{"titleProfile" | translate}}
            </label>
           <textarea name="" id="" cols="30" rows="4" class="form-control"  formControlName="description"></textarea>
          </div>
         </div>
     </form>
    </div>

  </div>

 </div>


<!-- Modal -->

<p-dialog header="{{'selectProfileImage' | translate}}" [(visible)]="cropLoad"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [style]="{ width: '25rem' }" [draggable]="false" [resizable]="false">
  <div class="p-3 d-grid" >
    <input type="file" (change)="onFileChanges($event)" class="form-control" accept="image/*" capture="camera" *ngIf="!loading" />
    
    <button *ngIf="loading" type="button" class="btn btn-primary py-3  mb-2 rounded-4"    >
     <app-button-spinner></app-button-spinner>
 </button>
  </div>
 

</p-dialog>


<div class="d-block d-sm-block d-md-none d-lg-none d-xl-none mt-5">
  <app-bottom-nav></app-bottom-nav>
</div>
